import styled from 'styled-components';
import { Form } from 'antd';

interface IconButtonProps {
	$isSelected?: boolean;
	$isDisabled?: boolean;
}

export const CustomFormItem = styled(Form.Item)`
	margin: 0;

	label {
		font-size: 1.1rem;
	}

	.ant-form-item-required {
		display: flex;
		justify-content: flex-end;
		flex-direction: row-reverse;
	}
`;

export const IconButton = styled.div<IconButtonProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	opacity: ${({ $isDisabled }) => ($isDisabled ? '0.5' : '1')};
	border: 1px solid
		${({ $isSelected, theme }) => ($isSelected ? theme.colors.primary : theme.palette.secondary['150'])};
	background-color: ${({ $isSelected, theme }) =>
		$isSelected ? theme.colors.primary : theme.palette.secondary.white};

	&:hover {
		cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
	}

	svg {
		font-size: 1.4rem;
		color: ${({ $isSelected, theme }) => ($isSelected ? theme.palette.secondary.white : theme.colors.primary)};
	}
`;
